import {FC, useEffect, useState} from 'react';
import styles from './ContractPage.module.scss';
import {Layout} from '../../shared/ui/Layout';
import {
    addIcon,
    bonusUsersIcon,
    coinIcon,
    grayArrow,
    mellIcon,
    prize,
    prizeGreenRed,
    stacIcon,
    zmokIcon
} from '../../assets';
import {QuantityDetails} from '../../shared/ui/QuantityDetails';
import MenuItem from '../../shared/ui/MenuItem/MenuItem';
import ShodawButton from '../../shared/ui/ShadowButton/ShodawButton';
import {useNavigate} from 'react-router';

import Deposits from '../../entities/deposit/ui/Deposits/Deposits';

import {contractABI} from '../../shared/api/contract/config';
import {MainPoolInfo} from '../../shared/api/contract';
import {formatNumberString} from '../../utils/helper';
import {ConnectorType, useAppKitProvider} from '@reown/appkit/react';
import {modal} from '../../main';
import {MoonStaking} from '../../shared/api/contract/moon-staking';
import {useTranslation} from 'react-i18next';

const ContarctPage: FC = () => {
    const navigate = useNavigate();
    const [poolInfo, setPoolInfo] = useState<MainPoolInfo>();
    const [fetching, setFetching] = useState(true);
    const {walletProvider} = useAppKitProvider<ConnectorType>('eip155');
    const {t} = useTranslation();

    const moonStaking = new MoonStaking(import.meta.env.VITE_CONTARCT_ADDRESS, contractABI, walletProvider);

    useEffect(() => {
        if (!fetching) return;

        async function getInfo() {
            try {
                const poolInfo = await moonStaking.getMainPoolInfo();

                if (poolInfo) {
                    setPoolInfo(poolInfo);
                }
            } catch (error) {
                console.log(error);
            }
        }

        getInfo();
    }, [fetching]);

    // useEffect(() => {
    //     if (fetching) return;
    //
    //     const intervalId = setInterval(() => {
    //         moonStaking.getMainPoolInfo()
    //             .then(poolInfo => {
    //                 if (poolInfo) setPoolInfo(poolInfo)
    //             })
    //
    //     }, 5_000)
    //
    //     return () => clearInterval(intervalId)
    //
    // }, [fetching]);

    return (
        <Layout
            title={t('stacking')}
            bgColor1="rgba(61, 25, 164, 1)"
            bgColor2="rgba(88, 29, 186, 1)"
            bgColor3="rgba(183, 112, 255, 1)"
            bgColor4="rgba(175, 137, 255, 1)"
            bgColor5="rgba(193, 177, 255, 1)"
            icon={stacIcon}>

                <div className={styles.ContractPage}>
                    <div className={styles.quantityDetails}>
                        <QuantityDetails
                            icon={mellIcon}
                            title={t('total_staking')}
                            value={poolInfo ? formatNumberString(String(Number(poolInfo?.totalStaked) / 1000000000000000000)) : '0'}
                            backgroundColor="radial-gradient(50% 265.78% at 100% 100%, rgba(180, 188, 226, 0.12) 0%, rgba(180, 188, 226, 0.06) 100%) "
                            // bgIcon={coinIcon}
                            bgIconPosition={{bottom: '0', right: '0', top: '0', width: '63px', height: '100%'}}
                        />
                        <QuantityDetails
                            icon={grayArrow}
                            title={t('actual_apr')}
                            value={`${
                                poolInfo && Number(poolInfo.rewardPerSecond) > 0 && Number(poolInfo.totalWeight) > 0
                                    ? (((Number(poolInfo.rewardPerSecond) * 31_536_000) / Number(poolInfo.totalWeight)) * 100).toFixed(2)
                                    : 0
                            }%`}
                            backgroundColor="radial-gradient(50% 265.78% at 100% 100%, rgba(180, 188, 226, 0.12) 0%, rgba(180, 188, 226, 0.06) 100%) "
                            // bgIcon={zmokIcon}
                            bgIconPosition={{bottom: '0', right: '0', top: '0', width: '55px', height: '100%'}}
                        />
                    </div>

                    <MenuItem
                        icon={prize}
                        link="/contract/bonuses"
                        title={t('get_rewards')}
                    />

                    <Deposits setFetching={() => setFetching(true)}/>

                    <ShodawButton
                        onClick={() => navigate('/contract/new')}
                        title={t('new_deposit')}
                        icon={addIcon}
                    />
                </div>


        </Layout>
    );
};

export default ContarctPage;
